module.exports = __webpack_public_path__ + "img/layer-17@2x.b2a39a62.png";